import { fillPageToken, type QuestionnaireField } from "@repo/questionnaire";
import { H2 } from "@/components/ui/heading";
import { PortalTrustNote } from "@/components/flow/portal-trust-note";
import { QuestionnaireFeedback } from "./questionnaire-feedback";
import { isPrivateContactField } from "./questionnaire-runner-values";
import type { QuestionnaireRunnerProps } from "./questionnaire-runner-types";
import type { QuestionnaireState } from "./use-questionnaire-state";

export function QuestionnaireStepHeading({
  props,
  state,
  question,
  description,
}: {
  props: QuestionnaireRunnerProps;
  state: QuestionnaireState;
  question: QuestionnaireField | null;
  description?: string | null;
}) {
  const { flow, chromeLabel, currentFields } = state;
  const { chrome, brand } = props;
  return (
    <div data-questionnaire-heading className="flex flex-col gap-2">
      <QuestionnaireFeedback props={props} state={state} />
      <H2 className="text-pretty text-xl font-semibold leading-snug tracking-tight sm:text-2xl">
        {fillPageToken(
          chromeLabel(question?.label ?? flow.currentStep.title),
          brand?.name ?? "Your broker",
        )}
      </H2>
      {chrome === "lead" &&
      brand &&
      currentFields.some(isPrivateContactField) ? (
        <PortalTrustNote
          compact
          brokerName={brand.name}
          message={chromeLabel(
            "Your details are only shared with {broker}.",
          ).replaceAll("{broker}", brand.name)}
        />
      ) : null}
      {description && (
        <p
          className={
            chrome === "lead"
              ? "max-w-prose text-sm leading-6 text-muted-foreground"
              : "text-base leading-relaxed text-muted-foreground"
          }
        >
          {chromeLabel(description)}
        </p>
      )}
    </div>
  );
}
